import { gql } from '@apollo/client';

export const fetchTransactionAccountBalanceDetailsQuery = gql`
  query fetchTransactionAccountBalanceDetailsQuery($id: ID!) {
    transactionAccount(id: $id) {
      transactionAccountBalanceEntity {
        createdAt
        type
        amount
        invoiceNumber
        endingAmount
      }
    }
  }
`;
